module.exports = __webpack_public_path__ + "img/Unity.4732900e.png";